export default __webpack_public_path__ + "static/media/project_lg_autopartes_4.cc82d3f5.png";